module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "content-t",
    attrs: {
      "id": "calibre_toc_1"
    }
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("Real Life Organizing")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-number"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Clean and Clutter-Free in 15 Minutes a Day")]), _c('span', {
    staticClass: "normal-caps1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Cassandra Aarssen"), _c('span', {
    staticClass: "normal-caps2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame",
    attrs: {
      "alt": "MangoLogo.png",
      "src": "OEBPS/image/MangoLogo_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3762ffde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_000.vue
// module id = 57
// module chunks = 0